import * as React from "react";

type ToastContentProps = {
  icon?: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  text: string;
  children?: React.ReactNode;
};

export function ToastContent({
  icon: Icon,
  children,
  text,
}: ToastContentProps) {
  return (
    <div className="flex flex-col">
      <div className="flex items-center">
        {Icon && (
          <div className="mr-1">
            <Icon className="text-white" />
          </div>
        )}
        <span>{text}</span>
      </div>
      {children}
    </div>
  );
}
